import React, { useEffect, useState } from "react";
import { CircleCheck, LoaderCircle } from 'lucide-react';
import { X } from "lucide-react";

const TestSyncModal = ({ isOpen, onClose, onConfirm, rows, setRows }) => {
    const [isProcessing, setIsProcessing] = useState(true);
    useEffect(() => {
        if (!isOpen) return;
        // proceed to check the verification backend
        setIsProcessing(true);
        setRows(prev =>
            prev.map(row => ({
              ...row,
              loading: true,
              verified: false
            }))
        );
        setTimeout(() => {
            setRows(prev =>
                prev.map(row => ({
                  ...row,
                  loading: false,
                  verified: true,
                  product_name: 'Samsung Galaxy S25 + Plus 5G Snapdragon 8 Elite | S24 + Plus 5G | 256GB 512GB | 1 Year Samsung Warranty | SG Local Set',
                  sku_name: 'S25 Plus 12GB 256GB, Navy',
                  product_price: 'SGD 1,113.00',
                  prioduct_stock: '10',
                }))
            );
            setIsProcessing(false);
        }, 3000);

    }, [isOpen]);
    
  if (!isOpen) return null;

  return (
    <>
      <div
        className="drawer-overlay"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={onClose}
      />
      <div
        className="entity-drawer modal-popup-cls"
        style={{
          maxWidth: 872,
          margin: "0 auto",
          background: "white",
          borderRadius: 12,
          zIndex: 1050,
          padding: 24,
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          height: "auto",
          right: "auto",
        }}
      >
        {/* Header */}
        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Title */}
        <h3
          style={{
            textAlign: "left",
            color: "#212529",
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "24px",
            fontFamily: "Montserrat",
            marginBottom: "20px",
          }}
        >
          Test Sync
        </h3>

        {/* Description */}
        <div className="new-look">
            <div className="entities-tab test-sync" style={{padding: 0}}>
                <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                    <table className="entities-table tab-table w-100">
                        <thead height="45px">
                            <tr>
                                <th><span>Platform</span></th>
                                <th><span>Product Name</span></th>
                                <th><span>SKU Name</span></th>
                                <th><span>Product Price</span></th>
                                <th><span>Product Stock</span></th>
                            </tr>
                        </thead>
                        <tbody>
                        {rows.map((r, idx) => (
                            <tr>
                                <td>
                                    {
                                        r.loading 
                                        ? <LoaderCircle className="loading" size={16} /> 
                                        : ""
                                    }
                                    {
                                        r.verified 
                                        ? <CircleCheck className="verified" size={16} />
                                        : ""
                                    }&nbsp;&nbsp;
                                    {r.platform}
                                </td>
                                <td>{r.product_name}</td>
                                <td>{r.sku_name}</td>
                                <td>{r.product_price}</td>
                                <td>{r.prioduct_stock}</td>
                            </tr>
                        ))}
                        </tbody>
                    
                    </table>
                </div>
            </div>
        </div>
        

        {/* Footer */}
        <div className="drawer-footer" style={{ paddingTop: "10px" }}>
          <button className="btn-save" onClick={onConfirm}>
            { isProcessing ? 'Abort' : 'Done'  }
          </button>
        </div>
      </div>
    </>
  );
};

export default TestSyncModal;
